import "core-js/modules/es.array.push.js";
import { useRoute, useRouter } from "vue-router";
import { Microphone } from "@element-plus/icons-vue";
import { useStore } from "vuex";
import { reactive, ref } from "vue";
import Recorder from "@/components/exam/Recorder-Player.vue";
export default {
  components: {
    Recorder
  },
  setup() {
    let router = useRouter();
    let route = useRoute();
    //音频播放状态
    let audioStatus = ref("yet");
    //步骤
    let step = ref(0);
    let store = useStore();
    function changeStep(no) {
      //音频暂停
      let audio = document.getElementById("test_audio");
      audio.pause();
      audio.load();
      audioStatus.value = "yet";
      //录音暂停
      recorderStatus.value = "yet";
      if (no === 0) {
        step.value = no;
      } else {
        step.value++;
      }
    }
    let {
      playTest
    } = usePlyer(audioStatus);
    let {
      allTime,
      recording,
      stopRecorder,
      playRecorder,
      setScores,
      startRecorder,
      recorderStatus,
      record_switch,
      stop_switch,
      replay_switch,
      recorderText,
      countDown
    } = useRecorder(changeStep, audioStatus);
    function goExam() {
      window.sessionStorage.setItem("oraltestPass", true);
      if (route.meta.trial) {
        router.push({
          path: "/trial/exam/oral",
          query: route.query
        });
      } else if (window.localStorage.getItem("exam-note") && window.localStorage.getItem("exam-note").indexOf("定制") != -1) {
        router.push({
          path: "/exam/oralgc",
          query: route.query
        });
      } else if (window.localStorage.getItem("exam-note") && window.localStorage.getItem("exam-note").indexOf("句子复述（试测）") != -1) {
        router.push({
          path: "/exam/oralq",
          query: route.query
        });
      } else {
        router.push({
          path: "/exam/oral",
          query: route.query
        });
      }
    }
    function recorderDefeat() {
      router.back();
    }
    return {
      recorderDefeat,
      goExam,
      allTime,
      store,
      audioStatus,
      step,
      playTest,
      changeStep,
      Microphone,
      recording,
      stopRecorder,
      playRecorder,
      setScores,
      startRecorder,
      recorderStatus,
      record_switch,
      stop_switch,
      replay_switch,
      recorderText,
      countDown
    };
  }
};
//播放器
function usePlyer(audioStatus) {
  // 示例播放
  function playTest() {
    let audio = document.getElementById("test_audio");
    audio.play();
    audioStatus.value = "ing";
  }
  return {
    playTest
  };
}
//录音器
function useRecorder(changeStep, audioStatus) {
  //录音状态
  let recorderStatus = ref("yet");
  //录音开关
  let record_switch = ref(false);
  //停止录音开关
  let stop_switch = ref(false);
  //播放开关
  let replay_switch = ref(false);
  //录音机信息
  let recorderInfo = reactive({});
  //文案
  let recorderText = ref("");
  //倒计时
  let allTime = 3;
  let countDown = ref(3);
  //定时器
  let timer;
  // 开始录音
  function startRecorder() {
    recorderStatus.value = "loading";
    //3s为准备时间
    recorderText.value = `录音倒计时中，3s`;
    countDown.value = 3;
    timer = setInterval(() => {
      if (countDown.value <= 0) {
        clearInterval(timer);
        record_switch.value = !record_switch.value;
      } else {
        countDown.value = countDown.value - 1;
        recorderText.value = `录音倒计时中，${countDown.value}s`;
      }
    }, 1000);
  }
  //录音中回调
  function recording() {
    recorderText.value = `正在录音..`;
    recorderStatus.value = "ing";
    countDown.value = allTime;
    //动画
    timer = setInterval(() => {
      if (countDown.value <= 0) {
        clearInterval(timer);
        stop_switch.value = !stop_switch.value;
      } else {
        countDown.value = countDown.value - 1;
      }
    }, 1000);
  }
  //停止录音回调
  function stopRecorder() {
    clearInterval(timer);
    stop_switch.value = !stop_switch.value;
    recorderText.value = `录音结束`;
    recorderStatus.value = "over";
  }
  //播放
  function playRecorder() {
    audioStatus.value = "ing";
    replay_switch.value = !replay_switch.value;
  }
  //获取分数
  function setScores(info) {
    Object.assign(recorderInfo, info);
    recorderText.value = ``;
    recorderStatus.value = "yet";
    changeStep();
  }
  return {
    countDown,
    allTime,
    recording,
    stopRecorder,
    playRecorder,
    setScores,
    startRecorder,
    recorderStatus,
    record_switch,
    stop_switch,
    replay_switch,
    recorderText
  };
}